const checkStartScroll  = () => {
  const breakpoint = window.matchMedia('(max-width:767px)');
  const header = document.querySelector('[data-header]');

  if (!header) {
    return;
  }

  const checkScroll = () => {
    if (document.documentElement.scrollTop > header.offsetHeight) {
      header.classList.add('header--shadow');
    } else {
      header.classList.remove('header--shadow');
    }
  }

  // window.addEventListener('scroll', checkScroll);

  const breakpointChecker = () => {
    if (breakpoint.matches) {
      window.addEventListener('scroll', checkScroll);
    } else {
      window.removeEventListener('scroll', checkScroll);
    }
  };

  breakpoint.addListener(breakpointChecker);
  breakpointChecker();
};

export {checkStartScroll};
